import SomaPlacePage from "./SomaplacePage";
export default SomaPlacePage;
